import http from 'plugins/axios';

export default {
  //获取交易对
  getPairList() {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList', data: { type: 'SPOT' }
    })
  },
  //动态查寻限价委托列表
  getOrderList(data) {
    return http.get({
      url: '/ta/admin/order/limit/findAll',
      data
    })
  },
  //按筛选条件导出现货委托
  exportExcel(data) {
    return http.get({
      url: '/ta/admin/order/limit/findAll/excel',
      data,
      responseType: 'blob'
    })
  },
  //撤销订单
  cancleOrder(orderId) {
    return http.post({
      url: `/ta/admin/order/limit/${orderId}/cancel`
    })
  },
  //查询成交列表明细
  getOrderDetails(data) {
    return http.get({
      url: '/ta/admin/order/limit/dealList',
      data
    })
  },
  //一键撤销
  cancelAll(data) {
    return http.post({
      url: '/ta/admin/order/cancel-all',
      data
    })
  }


};
